module.exports = __webpack_public_path__ + "static/media/spradling-logo.277a9efe.svg";